import { render, staticRenderFns } from "./DefaultSlider.vue?vue&type=template&id=7b7b3c1c&"
import script from "./DefaultSlider.vue?vue&type=script&lang=js&"
export * from "./DefaultSlider.vue?vue&type=script&lang=js&"
import style0 from "./DefaultSlider.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports